import { EmailAuditStatus } from '../../../schemas/EmailAudit.schema';
import { IStatusRendererParams } from '../../../components/AgTable/cell-renderers/StatusRenderer';

type StatusRendererStatus = IStatusRendererParams['status'];

// Per-recipient delivery status → StatusRenderer icon bucket + label. Used by
// the email-delivery detail modal so its pills match the aggregate indicator.
const STATUS_DISPLAY: Record<EmailAuditStatus, { status: StatusRendererStatus; label: string }> = {
  delivered: { status: 'success', label: 'Delivered' },
  sent: { status: 'pending', label: 'Sent' },
  delayed: { status: 'warning', label: 'Delayed' },
  bounced: { status: 'error', label: 'Bounced' },
  complaint: { status: 'error', label: 'Complaint' },
  rejected: { status: 'error', label: 'Rejected' },
  failed: { status: 'error', label: 'Failed' },
};

export function emailAuditStatusDisplay(status: EmailAuditStatus): {
  status: StatusRendererStatus;
  label: string;
} {
  return STATUS_DISPLAY[status];
}
